import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-calendar-year-detail-note',
  templateUrl: './calendar-year-detail-note.component.html',
  styleUrls: ['./calendar-year-detail-note.component.css']
})
export class CalendarYearDetailNoteComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
  }

}
